import { Injectable } from '@angular/core';

/** Collapse one concurrent denial burst, never unrelated errors or another session/status. */
@Injectable({ providedIn: 'root' })
export class SubscriptionRestrictionPresentationService {
  private last: { session: string | null | undefined; version: number | undefined; status: string; until: number } | null = null;

  claim(session: string | null | undefined, version: number | undefined, status: string): boolean {
    const now = Date.now();
    if (this.last && this.last.session === session && this.last.version === version
        && this.last.status === status && now < this.last.until) return false;
    this.last = { session, version, status, until: now + 6000 };
    return true;
  }
}
